import { Component, Input } from '@angular/core';

enum ERfqStatus {
  AVAILABLE = 'Available',
  UNAVAILABLE = 'Unavailable',
}

@Component({
  selector: 'lum-rfq-status',
  templateUrl: './rfq-status.component.html',
  styleUrls: ['./rfq-status.component.scss'],
})
export class RfqStatusComponent {
  @Input()
  item :any; // TODO: CREATE TYPE

  overlapTrigger :boolean = false;

  get status() :ERfqStatus {
    if (!this.item.location_stock) {
      return ERfqStatus.UNAVAILABLE;
    }

    const available =
      this.item.location_stock.qty_onhand - this.item.location_stock.qty_pending;
    const lineQty = this.item.quantity;

    if (available <= 0 || lineQty >= available) {
      return ERfqStatus.UNAVAILABLE;
    }

    return ERfqStatus.AVAILABLE;
  }

  get classes() :string[] {
    const color = this.status === ERfqStatus.AVAILABLE ? 'purple' : 'red';

    return [
      `text-${color}-800`,
      `bg-${color}-200`,
      `hover:${color}-400`,
      `active:${color}-500`,
      `focus:${color}-400`,
      'p-2',
    ];
  }

  get matMenuTrigger() :string {
    return `matMenuTrigger${this.item.id}`;
  }
}
